import { render } from "./Logo.vue?vue&type=template&id=15c8ca4e"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"
script.render = render

export default script